import LogRocket from 'logrocket';
if (process.env.REACT_APP_RELEASE_VERSION) {
  LogRocket.init('gcoxl1/virtual-engineer-dashboard', {
    mergeIframes: true,
    release: `${process.env.REACT_APP_RELEASE_VERSION}`,
  });
}
import React, { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBars,
  faBook,
  faBriefcase,
  faCaretDown,
  faCaretRight,
  faCartShopping,
  faChevronDown,
  faCircleExclamation,
  faFile,
  faMagnifyingGlass,
  faPen,
  faPlus,
  faRss,
  faTags,
  faTrashCan,
  faUser,
  faXmark,
  faCircleLeft,
  faGears,
  faUserPlus,
} from '@fortawesome/free-solid-svg-icons';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { faTwitter, faFacebookF, faYoutube, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons';

import { setAxiosConfig } from './config/AxiosConfig';
import { StyledEngineProvider } from '@mui/material/styles';

import * as i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { GenericLoadingScreen } from './components/GenericLoadingScreen/GenericLoadingScreen';
import * as wjcCore from '@mescius/wijmo';
wjcCore.setLicenseKey(
  'virtualengineerdev.parker.com|localhost|virtualengineer.parker.com|virtualengineerpreview.parker.com|virtualengineertest.parker.com|virtualengineerdev.us.parker.corp|localvedashboard.parker.com,172845673678899#B0HbgVHdylmdiojIz5GRiwiIjJXQuVGcPJiOiEmTDJCLikTO8gzN6MzN6UDN8IzNxIiOiQWSiwSfdtlOicGbmJCLiIjd4IDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPR9mbSZWUzIVTGBDNhFXTz94MnB7ShdDMXhlVoJTNo9mNmJVZHZWewt4MK3CO4ZEVmVHbLlFaZFDWBlTWTZ5T7xGakZ5apVEdxQ6S7UzUvZ6Z6cTVjZmdzIzdjVTSysWZvJVbDl4aaRVU8kncP5UNuhTOSBzLOdzd5FTQsNFaPRmNSZzKLlDSIZzdQRESzUUUmV4M9M5NWdjdmlUMI5UVqtyYRF7QtNmc8kkQ4FWaGRVVYZVbh3UVxp6VwlGO49GT8xUcthkawtiVOF7a9cTelxkdSV5RWNGSqVFdD34MDRzRxMjMvFleysUcXF5Zv2ETH56THdFWCh5RW5WVYxURUBVT9E4TppEaqFzVFtEaB3WNMFUWR5kVXh5YxEnUURXM9QjaXdkcalGNrE6MndmQMBXV7cEeQ56V8UVMSVlaKVDRlZ5U45GVj3yKtFkN6dnUZZDULJnaiojITJCLiQUM9EENBRkMiojIIJCL6QDM7gzN7ETM0IicfJye#4Xfd5nIJBjMSJiOiMkIsIibvl6cuVGd8VEIgQXZlh6U8VGbGBybtpWaXJiOi8kI1xSfiUTSOFlI0IyQiwiIu3Waz9WZ4hXRgAicldXZpZFdy3GclJFIv5mapdlI0IiTisHL3JyS7gDSiojIDJCLi86bpNnblRHeFBCI73mUpRHb55EIv5mapdlI0IiTisHL3JCNGZDRiojIDJCLi86bpNnblRHeFBCIQFETPBCIv5mapdlI0IiTisHL3JyMDBjQiojIDJCLiUmcvNEIv5mapdlI0IiTisHL3JSV8cTQiojIDJCLi86bpNnblRHeFBCI4JXYoNEbhl6YuFmbpZEIv5mapdlI0IiTis7W0ICZyBlIsIyNwQTN5ADIzIjNwUjMwIjI0ICdyNkIsISbvNmLyV6ayFGcuQmch3mYoNXYkVmdsF6YvxGLwJ7bj9icltmchBnLzVnL6VGZyVWZul6ZuVGbhVHdylmds46bj9icltmchBnL4NXZ4JXZl9Wan9WZsFWd4JXa6xSbvNmLyV6ayFGcucXZpZXZyBnclVmbpdmblxWY5RncpZHLt36YuIXZrJXYw9iclVmbpdmblxWY5RncpZHL4N7boxWYj3Gbs46bj9icltmchBnL6VGZyVWZulUZ5V',
);

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    detection: {
      order: ['cookie'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: process.env.PUBLIC_URL + '/locales/{{lng}}/{{ns}}.json',
    },
  });

library.add(
  faMagnifyingGlass,
  faBars,
  faPlus,
  faCaretRight,
  faCaretDown,
  faFile,
  faXmark,
  faCircleExclamation,
  faTrashCan,
  faPen,
  faCircleCheck,
  faTags,
  faCartShopping,
  faChevronDown,
  faUser,
  faRss,
  faTwitter,
  faFacebookF,
  faYoutube,
  faLinkedinIn,
  faInstagram,
  faBook,
  faBriefcase,
  faCircleLeft,
  faGears,
  faUserPlus,
);

setAxiosConfig();

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <StyledEngineProvider injectFirst>
      <Suspense fallback={<GenericLoadingScreen />}>
        <App />
      </Suspense>
    </StyledEngineProvider>
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
